import React, {FC, useEffect, useState} from "react";
import AppUtil from "../../util/AppUtil";
import AppConstants from "../../util/AppConstants";
import GatewayService from "../../service/GatewayService";
import {CombosComp, ComboHead} from "./opp/OppHelper";
import {DropDownCompNumber, DropDownCompString, getKeyVal, getKeyValArray} from "../util/DropDownComp";
import {CheckboxComponent} from "../util/CheckboxComponent";
import { useClients } from "../../context/ClientsContext";
import { useChain } from "../../context/ChainContext";
import {Combo} from "../../models/Combo";

interface Props {
}
let defaultSorter:(a:Combo, b:Combo)=>number = (a:Combo, b:Combo) => b.absProfit - a.absProfit
export function ComboList(props: { combos: Combo[], clientId:string }) {
    const map = AppConstants.sorterMap
    const[flag, setFlag] = useState(false);

    function sort(sortBy: string) {
        const isAsc = map.get(sortBy) || false
        // @ts-ignore
        defaultSorter = (a, b)=>isAsc?a[sortBy]-b[sortBy] : b[sortBy] - a[sortBy]
        map.set(sortBy, !isAsc)
        setFlag(!flag)
    }

    let getCombos = ()=>props.combos.sort(defaultSorter)
    if(props.combos.length===0)return <></>
    return <table className={"full"}>
        <ComboHead func={sortBy => sort(sortBy)}/>
        <tbody>
        {getCombos().map(option => <CombosComp key={option.id} combo={option} clientId={props.clientId}/>)}
        </tbody>
    </table>
}

export const OptionOppComponent:FC<Props> = (props) => {
    const { clients } = useClients();
    const { chain, setChain } = useChain();
    const [combosPNC, setCombosPNC] = useState<Array<Combo>>([]);
    const [combosOptimised, setCombosOptimised] = useState<Array<Combo>>([]);
    const [ytm, setYtm] = useState(-1);
    const [minProfit, setMinProfit] = useState(-1);
    const [type, setType] = useState("");
    const [exchange, setExchange] = useState("");
    // const [exchange, setExchange] = useState("");
    // const [name, setName] = useState("");
    const [buyExpiry, setBuyExpiry] = useState(-1);
    const [sellExpiry, setSellExpiry] = useState(-1);
    const [time, setTime] = useState(AppConstants.YEAR);
    const[sameExpiry, setSameExpiry] = useState(false);
    const[expiryDayNFO, setExpiryDayNFO] = useState(false);
    const[withoutMargin, setWithoutMargin] = useState(false);
    const[loan, setLoan] = useState("");
    const [client, setClient] = useState("");
    const[timestamp, setTimestamp] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(()=>{
        if (client) {
            refresh()
        }
    }, [withoutMargin, time, sameExpiry, loan, expiryDayNFO, client])

    useEffect(()=>{
        document.addEventListener("keydown",
            function (event) {
                if(event.key.toLowerCase()==="r")refresh()
            });
    }, [])

    useEffect(()=>{
        setSellExpiry(-1)
        setBuyExpiry(-1)
        // GatewayService.getOpportunity2().then(setCombos2)
    }, [type])

    useEffect(() => {
        if (clients && clients.length > 0 && client === "") {
            setClient(clients[0]);
        }
    }, [clients, client]);

    let current = AppUtil.currentTime();
    let combosPnc = combosPNC
        .filter(filter)
        .sort(defaultSorter)

    function filter(combo:Combo):boolean{
        let retain = (combo.ytm>ytm || ytm === -1) &&
            (type==="" || (type===combo.type) ||
                (type==="no_brain" && AppConstants.noBrainerComboTypes.indexOf(combo.type)!==-1) ||
                (type==="futureComboTypes" && AppConstants.futureComboTypes.indexOf(combo.type)!==-1)
            ) &&
            (combo.minProfit>minProfit || minProfit===-1) &&
            (combo.name===chain||chain==="") &&
            (combo.buyExpiry===buyExpiry || buyExpiry===-1) &&
            (combo.exchange===exchange || exchange==="") &&
            (combo.sellExpiry===sellExpiry || sellExpiry===-1) &&
            (combo.time<=time) &&
            (!sameExpiry || combo.buyExpiry === combo.sellExpiry) &&
            (loan==="" || ((loan==="yes")?combo.effectiveCapital<=0 : combo.effectiveCapital>=0) )
        return retain
    }

    let optimisedCombos = combosOptimised
        .filter(filter)
        .sort(defaultSorter)

    function refresh() {
        setIsLoading(true);
        // GatewayService.getOpportunityPNC(props.chain, withoutMargin).then(setCombosPNC)
        if (!client) {
            setIsLoading(false);
            return; // Don't call API if client is not set
        }
        
        if (expiryDayNFO){
            GatewayService.getOpportunityForExpiry().then(setCombosOptimised).finally(()=>setIsLoading(false))
        }else{
            GatewayService.getOpportunityOptimized(chain, withoutMargin, buyExpiry, type==="no_brain", client).then(setCombosOptimised).finally(()=>setIsLoading(false))
        }

    }

    function getInstantOpp() {
        setIsLoading(true);
        GatewayService.getOpportunityInstant(timestamp, chain, buyExpiry).then(setCombosOptimised).finally(()=>setIsLoading(false))
        // GatewayService.getOpportunityInstant(1712740458561, "NAVINFLUOR", 1714003200000).then(setCombos2)
    }

    function getNames(){
        let set =  new Set(combosOptimised.map(it=>it.name))
        return Array.from(set.values())
    }

    function getExpires(isBuy:boolean = false){
        let set =  new Set(optimisedCombos.map(it=>isBuy?it.buyExpiry:it.sellExpiry))
        return getKeyValArray(Array.from(set.values()).sort(AppUtil.sort), (it)=> AppUtil.getTime(it))
    }

    function getTimes(){
        return getKeyValArray([AppConstants.DAY, AppConstants.WEEK, AppConstants.MONTH, AppConstants.YEAR], (it)=> (it/AppConstants.DAY).toString())
    }

    function getExchanges(){
        let set = new Set(optimisedCombos.map(it=>it.exchange))
        return getKeyValArray(Array.from(set.values()).sort(), (it)=> it)
    }

    function getClients(){
        return getKeyVal(clients || []);
    }

    if (isLoading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <div className="loading-text">Loading opportunities...</div>
            </div>
        );
    }

    if (optimisedCombos.length === 0) {
        return (
            <div className="tab">
                <button onClick={() => refresh()}>refresh</button>
                <span>No opportunities</span>
            </div>
        );
    }

    return<>
        <DropDownCompString text={"select client"} actual={client} arr={getClients()} set={setClient}/>
        <div className={"tab"}>chain = <input type="text" value={chain} onChange={event => setChain(event.target.value)}/></div>
        <div className={"tab"}>min profit = <input type="number" value={minProfit} onChange={event => setMinProfit(parseFloat(event.target.value))}/></div>
        <div className={"tab"}>min ytm = <input type="number" value={ytm} onChange={event => setYtm(parseFloat(event.target.value))}/></div>
        <div className={"tab"}>timestamp = <input type="text" value={timestamp} onChange={event => setTimestamp(parseInt(event.target.value))}/></div>
        <CheckboxComponent text={"sameExpiry"} actual={sameExpiry} val={sameExpiry} set={setSameExpiry}/>
        <CheckboxComponent text={"expiryDayNFO"} actual={expiryDayNFO} val={expiryDayNFO} set={setExpiryDayNFO}/>
        <CheckboxComponent text={"withoutMargin"} actual={withoutMargin} val={withoutMargin} set={setWithoutMargin}/>
        <DropDownCompString text={"capital -ve"} actual={loan} arr={getKeyVal(["yes", "no"])} set={setLoan}/>
        <DropDownCompString text={"select type"} actual={type} arr={getKeyVal(["no_brain", "futureComboTypes", ...AppConstants.comboTypes])} set={setType}/>
        <DropDownCompString text={"select exchange"} actual={exchange} arr={getExchanges()} set={setExchange}/>
        {/*<DropDownCompString text={"select name"} actual={name} arr={getKeyVal(getNames())} set={setName}/>*/}
        <DropDownCompNumber text={"select buy expiry"} actual={buyExpiry} arr={getExpires(true)} set={setBuyExpiry}/>
        <DropDownCompNumber text={"select sell expiry"} actual={sellExpiry} arr={getExpires(false)} set={setSellExpiry}/>
        <DropDownCompNumber text={"max time"} actual={time} arr={getTimes()} set={setTime}/>
        <button onClick={()=>refresh()}>refresh</button>
        <button onClick={getInstantOpp}>instant</button>
        <ComboList combos={optimisedCombos} clientId={client}/>
        -------------------------------------------------------------<br/>
        -------------------------------------------------------------<br/>
        -------------------------------------------------------------<br/>

                SECOND TABLE
        -------------------------------------------------------------<br/>
        -------------------------------------------------------------<br/>
        -------------------------------------------------------------<br/>

        <ComboList combos={combosPnc} clientId={client}/>
    </>
}

// export default OptionOppComponent